/** Imports */
import * as controller from './controller.js';
import * as view from './view.js';
import * as model from './model.js';

/** Initialization */
// let basicSettings = {
// 	plan: 'BASIC',
// 	config: {
// 		id:
// 			'wizard' +
// 			Math.random()
// 				.toString()
// 				.substr(2),
// 		anchor: "form[action='/cart']",
// 		classes: { outerWrapper: '', innerWrapper: '', input: '', button: '' },
// 		description: 'Custom styling by Dcode Wizard',
// 		infoboxAnchor: '',
// 		infoboxLocation: '',
// 		location: 'afterend',
// 		style: { outerWrapper: '', innerWrapper: '', input: '', button: '' },
// 		theme: '',
// 		title: 'Wizard Config',
// 		wizard: true
// 	},
// 	activeStyle: '6f261bc8-f42b-432f-b58b-b1dc67b58b7c',
// 	appActive: true
// };
/** Functions */
export async function startWizard(shop) {
  localStorage.removeItem('dcSettingUp');
  console.log('Dcode Setup started', shop);
  // const style = document.createElement('style');
  // style.innerHTML = `.dcodeWizard {
  // 	position: fixed;
  // 	width: 100%;
  // 	height: 300px;
  // 	background-color: rgba(255, 255, 255, 0.79);
  // 	bottom: 0;
  // 	z-index: 9999;
  // 	border: 10px solid rgba(0, 0, 0, 0.50);
  // }`;
  // document.querySelector('head').insertAdjacentElement('beforeend', style);
  // basicSettings.config.shop = shop;
  // localStorage.setItem('dcodeSetupSettings', JSON.stringify(basicSettings));
  await model.saveCartAndCurrency(false, shop);
  const script = document.createElement('script');
  script.src = 'https://dcodewizard.netlify.app/wizard.js';
  script.id = 'dcodeWizardScript';
  document
    .querySelector('head')
    .insertAdjacentElement('beforeend', script);
  //setupWithNewConfig();
}

// function wizardPage(page) {
// 	let onclick;
// 	switch (page) {
// 		case 'start':
// 			onclick = () => {
// 				console.log('Clicked');
// 			};
// 			detectClick(element => {
// 				const anchor = getPath(element);
// 				console.log('New anchor: ', anchor);
// 				updateSettings('anchor', anchor);
// 				setupWithNewConfig();
// 			});
// 	}

// 	document.querySelectorAll('.dcodeWizard').forEach(e => e.remove());
// 	const body = document.querySelector('body');
// 	let wizardElement = getWizardElement(page, onclick);
// 	console.log('Wizard Element', wizardElement);
// 	body.insertAdjacentElement('beforeend', wizardElement);
// }

// function getWizardElement(page, onclick) {
// 	let html;
// 	switch (page) {
// 		case 'start':
// 			html = `
// 				<div id="dcodeWizard" class="dcodeWizard">
// 					<h2>Let's set up Dcode together</h2>
// 					<p>${page}</p>
// 					<p>Click on the position where you want the discount box to appear</p>
// 					<select>
// 						<option value="afterend">
// 					</select>
// 					${onclick ? '<button id="dcwNext">Next</button>' : ''}
// 				</div>
// 			`;
// 			break;
// 	}
// 	let element = document.createElement('div');
// 	element.innerHTML = html;
// 	element.firstElementChild;
// 	if (onclick) {
// 		const button = element.querySelector('#dcwNext');
// 		button.addEventListener('click', onclick);
// 	}
// 	return element;
// }

const setupWithNewConfig = async () => {
  const setupInProgress = localStorage.getItem('dcSettingUp');
  console.log('Setting up with new config');
  if (!setupInProgress) {
    localStorage.setItem('dcSettingUp', 'true');
    document
      .querySelectorAll('.dcodeOuterWrapper')
      .forEach(e => e.remove());
    let settings = localStorage.getItem('dcodeSetupSettings');
    console.log('settings', settings);
    if (settings) {
      console.log('DC - setup new');
      view.clearDiscount();
      settings = JSON.parse(settings);
      await controller.startSetup(settings, true);
      // Display discount but prevent validation
      sessionStorage.setItem('dcValidating', 'true');
      view.updateCart(null, 'EXAMPLE', -10.0, null, settings);
      sessionStorage.removeItem('dcValidating');
    }
    localStorage.removeItem('dcSettingUp');
  }
};
window.setupWithNewConfig = setupWithNewConfig;

// function updateSettings(key, value) {
// 	let settings = localStorage.getItem('dcodeSetupSettings');
// 	if (settings) {
// 		settings = JSON.parse(settings);
// 		settings.config[key] = value;
// 		localStorage.setItem('dcodeSetupSettings', JSON.stringify(settings));
// 	}
// }
